<template src="./form.html"></template>

<script>
import { UpdateLbRef, ViewLbRef } from '@/api/lb.ref'

export default {
  name: 'edit-lb',
  data: function () {
    return {
      model: {
        id: '',
        gender: null,
        genderText: '',
        item: '',
        lower: null,
        upper: null
      },
      loading: false,
      ruleValidate: {}
    }
  },
  props: ['meta'],
  methods: {
    init: function (id) {
      ViewLbRef(id).then(async res => {
        this.model = res
      })
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      UpdateLbRef(this.model).then(async res => {
        if (res.id) {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
